const dsBridge = require('dsbridge')

const NATIVE_BACK_EVENT = 'h5-physical-back'

function emitNativeBack () {
  window.dispatchEvent(new Event(NATIVE_BACK_EVENT))
}

// 原生物理返回时调用，便于 H5 在关闭 WebView 前打点
dsBridge.register('onPhysicalBack', emitNativeBack)
// dsBridge.register('onBackPressed', emitNativeBack)

// 0：返回 1：首页 2：选择图片 3：银行卡页面 4:进入h5页面关闭loading
export default {
  install (Vue, options) {
    Vue.prototype.$javaNative = function (behavior, result) {
      if (behavior === 0) {
        emitNativeBack()
      }
      dsBridge.call('android.handle', JSON.stringify([behavior]),
        function (res) {
          if (result) result(JSON.parse(res))
        })
    }
  }
}
